import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({formData, setFormData}) => {

    const handleChange = (content) => {
        setFormData({...formData, description:content});
    }
   
  return <ReactQuill theme="snow" value={formData.description} onChange={handleChange} />;
}
export default RichTextEditor